import React, { useEffect, useState } from 'react'
import DisplayCard from '../../components/DisplayCard';
import { useNavigate } from 'react-router-dom';
import FilledButton from '../../components/ui/FilledButton';
import { getAllMissionsIds } from '../../services/api/missions/getMission';
import { removeMission } from '../../services/api/missions/removeMission';

const Missions = () => {
    const [itemsList, setItemsList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        getAllMissionsIds().then(response => {
            // console.log(response);
            if (response.error === null) {
                setItemsList(response.data);
                setIsLoading(false);
            }
        })
    },[]);

    const navigate = useNavigate();

    const handleEdit = (id) => {
        navigate(`/missions/edit/${id}`);
    }

    const handleDelete = async (id) => {
        const isConfirmed = window.confirm('Are you sure u want to delete this mission');
        if (isConfirmed) {
            const res = await removeMission(id);
            if (res.error === null) {
                alert('Deleted mission successfully');
            }else{
                alert('an error occurred');
            }
        }
    }

  return (
    <>
    <div className='flex justify-end items-center p-2'><FilledButton label={'create mission'} onClick={() => navigate('/missions/create')} /></div>
    <div className='flex gap-4 items-center flex-wrap'>
        {
            isLoading?'Loading...':itemsList?.map((item,ind) => <DisplayCard key={ind} title={item?.title} handleDelete={() => handleDelete(item?.mission_id)} handleEdit={() => handleEdit(item?.mission_id)} />)
        }
    </div>
        </>
  )
}

export default Missions